import script from "./infoScoreboardStd.vue?vue&type=script&setup=true&lang=js"
export * from "./infoScoreboardStd.vue?vue&type=script&setup=true&lang=js"

import "./infoScoreboardStd.vue?vue&type=style&index=0&id=3b671356&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b671356"]])

export default __exports__